import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
} from "@headlessui/react";
import clsx from "clsx";
import { FunctionComponent } from "react";

import MinusIcon from "@ui/components/icon/MinusIcon";
import PlusIcon from "@ui/components/icon/PlusIcon";
import { sharedStyles } from "@ui/shared-styles";

import * as styles from "./Group.css";

interface Props {
  title: string;
  children: React.ReactNode;
  className?: string;
  special?: boolean;
  defaultOpen?: boolean;
}

const Group: FunctionComponent<Props> = (props) => {
  return (
    <li className={clsx(props.className, styles.container)}>
      <Disclosure defaultOpen={props.defaultOpen}>
        {({ open }) => (
          <>
            <DisclosureButton
              className={clsx(
                styles.link,
                open && styles.linkOpened,
                props.special && styles.special,
              )}
              aria-label={`${open ? "Expand" : "Collapse"} '${
                props.title
              }' Section`}
            >
              {props.title}
              {open ? (
                <MinusIcon className={styles.subItemButtonIconOpen} />
              ) : (
                <PlusIcon className={styles.subItemButtonIcon} />
              )}
            </DisclosureButton>
            <DisclosurePanel static>
              <ul
                className={clsx(
                  !open && sharedStyles.layout.hide,
                  styles.subMenuContainer,
                )}
              >
                {props.children}
              </ul>
            </DisclosurePanel>
          </>
        )}
      </Disclosure>
    </li>
  );
};

export default Group;
